/* eslint-disable */
import { ORDERS_CANCELLATION, ORDERS_CANCELLATION_COMPLETE, ORDERS_CANCELLATION_ERROR, ORDERS_CANCELLATION_SUCCESS } from '../Orders.types';

/**
 * Confirm a specific `order` by its `date, orderCode`
 * @param {OrderServiceOrderConfirmationDto} dto The required params to confirm an order by its `date, orderCode`
 * @returns {ActionCreator<FromPromise>} The created `Action`
 */
const ordersCancelOrder = ({ companyCode, date, orderCode, orderKey, timezone }) => ({ orderService, fromPromise }) => {
  const promise = orderService.cancelOrder({ companyCode, date, orderCode, orderKey, timezone });
  return fromPromise(promise, { params: { date, orderCode, orderKey } }, [
    ORDERS_CANCELLATION,
    ORDERS_CANCELLATION_COMPLETE,
    ORDERS_CANCELLATION_ERROR,
    ORDERS_CANCELLATION_SUCCESS,
  ]);
};

export default ordersCancelOrder;
